class PartnerMarketplace extends HTMLElement {
  constructor() {
    super();
  }
}

customElements.define("partner-marketplace", PartnerMarketplace);

class PmProduct extends HTMLElement {
  constructor() {
    super();

    this.submitBtn = this.querySelector(".js-pm-product__buy-btn");
    this.submitBtn.addEventListener("click", this.addToCart.bind(this));
    this.cart =
      document.querySelector("cart-notification");

    this.mobileContentDropdownLogic();
    this.dropDownLogic();

    this.view = this.querySelector(".pm-product__view-info-btn");
    this.view.addEventListener("click", this.handleVIewInfo.bind(this));
  }
  handleVIewInfo() {
    this.querySelector(".pm-product__desktop-list").classList.toggle(
      "view-details",
    );
  }

  mobileContentDropdownLogic() {
    const dropdowns = this.querySelectorAll(
      ".pm-product__list-mobile .show-product-info",
    );
    dropdowns.forEach((dropdown) => {
      dropdown.addEventListener("click", () => {
        dropdown.closest(".pm-product__list-item").classList.toggle("open");
      });
    });

    this.querySelectorAll("select").forEach((select) => {
      select.addEventListener("change", () => {
        const price = this.querySelector(".price-saving-wrapper");
        const newPrice = price.querySelector(".new-price");
        const oldPrice = price.querySelector(".old-price");
        // const discount = price.querySelector(".percent-saved span");
        newPrice.innerHTML =
          "$" +
          (
            (Number(newPrice.dataset.price) * Number(select.value)) /
            100
          ).toLocaleString();
        oldPrice.innerHTML =
          "$" +
          (
            (Number(oldPrice.dataset.oldPrice) * Number(select.value)) /
            100
          ).toLocaleString();
      });
    });
  }

  dropDownLogic() {
    // Get all original selects (one per variant)
    const originalSelects = this.querySelectorAll(
      ".pm-product__original-select",
    );

    originalSelects.forEach((originalSelect) => {
      // For this logic to work, ensure each select and dropdown are associated somehow.
      // Here we assume each variant block wraps both the select and its corresponding custom dropdown.
      let variantBlock = originalSelect.closest(".product-info-row--summary");
      if (window.innerWidth < 769) {
        variantBlock = originalSelect.closest(".pm-product__list-item");
      }
      if (!variantBlock) {
        return;
      }
      const dropdownWrapper = variantBlock.querySelector(".custom-dropdown");
      const selectedDisplay = dropdownWrapper.querySelector(
        ".custom-dropdown__selected",
      );
      const dropdownOptionsContainer = dropdownWrapper.querySelector(
        ".custom-dropdown__options",
      );

      // Populate the custom dropdown with options from the original select
      Array.from(originalSelect.options).forEach((opt) => {
        const optionDiv = document.createElement("div");
        optionDiv.classList.add("custom-dropdown__option");
        optionDiv.textContent = opt.text;
        optionDiv.dataset.value = opt.value;
        dropdownOptionsContainer.appendChild(optionDiv);
      });

      // Set initial selected value
      selectedDisplay.textContent =
        originalSelect.options[originalSelect.selectedIndex].value;

      // Show/Hide dropdown on click
      selectedDisplay.addEventListener("click", () => {
        // Close all other dropdowns before opening this one (optional)
        this.querySelectorAll(".custom-dropdown.open").forEach(
          (openDropdown) => {
            if (openDropdown !== dropdownWrapper) {
              openDropdown.classList.remove("open");
            }
          },
        );
        dropdownWrapper.classList.toggle("open");
      });

      // Close dropdown if clicked outside
      document.addEventListener("click", (event) => {
        if (!dropdownWrapper.parentElement.contains(event.target)) {
          dropdownWrapper.classList.remove("open");
        }
      });

      // Handle option clicks
      dropdownOptionsContainer.addEventListener("click", (event) => {
        const optionEl = event.target.closest(".custom-dropdown__option");
        if (optionEl) {
          const newValue = optionEl.dataset.value;
          const newText = optionEl.textContent;

          // Update hidden select
          originalSelect.value = newValue;

          // Update displayed text
          selectedDisplay.textContent = newText;

          // Close dropdown
          dropdownWrapper.classList.remove("open");

          // Dispatch change event on original select
          const changeEvent = new Event("change", { bubbles: true });
          originalSelect.dispatchEvent(changeEvent);
        }
      });
    });
  }
  async addToCart() {
    let selector = `table .add-to-cart:checked`;
    let parentSelector = ".product-info-row--summary";
    if (window.innerWidth < 769) {
      selector = `.pm-product__list-mobile .add-to-cart:checked`;
      parentSelector = ".pm-product__list-item";
    }
    const variantsToAdd = Array.from(this.querySelectorAll(`${selector}`)).map(
      (element) => {
        const product = element.closest(parentSelector);
        const select = product.querySelector(".pm-product__qty-select");
        return {
          id: Number(select.dataset.id),
          quantity: Number(select.value),
          properties: {
            "_marketplace-item": "true",
          },
        };
      },
    );

    const formDataJSON = {
      items: variantsToAdd,
    };
    this.setCustomFormData(formDataJSON);
    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];

    const formData = this.customFormData || new FormData(this.form);

    if (this.cart) {
      formData.append(
        "sections",
        this.cart.getSectionsToRender().map((section) => section.id),
      );
      formData.append("sections_url", window.location.pathname);
      this.cart.setActiveElement(document.activeElement);
    }
    config.body = formData;

    // TODO: only a console log for debugging purposes is here - we should remove it completely if it isn't being used
    // To check the form data
    // if (this.customFormData) {
    //   for (let pair of this.customFormData.entries()) {
    //     console.log(pair[0] + ", " + pair[1]);
    //   }
    // }

    const response = await fetch(`${routes.cart_add_url}`, config);
    if (!response.ok) {
      alert(
        "ERROR when adding the product cart! Please refresh page and try again",
      );
    }
    const data = await response.json();
    if (!data.id) {
      data["id"] = String(variantsToAdd[0].id);
    }

    this.cart.renderContents(data);
  }

  setCustomFormData(formData) {
    if (formData instanceof FormData) this.customFormData = formData;
    else {
      this.customFormData = new FormData();
      formData.items.forEach((item, index) => {
        this.customFormData.append(`items[${index}][id]`, item.id);
        this.customFormData.append(`items[${index}][quantity]`, item.quantity);

        if (item.properties) {
          for (const prop in item.properties) {
            if (item.properties.hasOwnProperty(prop)) {
              this.customFormData.append(
                `items[${index}][properties][${prop}]`,
                item.properties[prop],
              );
            }
          }
        }
      });
    }
  }
}
customElements.define("pm-product", PmProduct);
